import { MarketAccountNames } from '@src/components/MarketAccountNames';
import { useAppStateDispatch } from '@src/providers/AppStateProvider/AppStateProviderHooks';
import { navigationSliceActions } from '@src/providers/AppStateProvider/navigationSlice';
import { getDisplayIdFromValue, getOrderStatusText, Order, OrderStatusText, useSecurity } from '@talos/kyoko';
import type React from 'react';
import { useMemo, useRef } from 'react';
import type { AppInboxToastProps } from '../../../components/GlobalToasts/AppInboxToast/AppInboxToast';
import { AppInboxToastBase } from '../../../components/GlobalToasts/AppInboxToast/AppInboxToastBase';
import { archiveNotification } from '../redux/AppNotificationsSliceActions';

export const OrderStatusNotificationToastContent = (props: AppInboxToastProps) => {
  const dispatch = useAppStateDispatch();
  const orderRef = useRef<Order>(new Order(props.notification.Payload));
  const security = useSecurity(orderRef.current.Symbol);

  const displayDetails = useMemo(() => {
    const order = orderRef.current;
    const orderStatusText = getOrderStatusText({ type: 'order', order, isCustomerOrder: false });
    let displayDescription: React.ReactNode = props.description;
    const securityName = security?.DisplaySymbol ?? order.Symbol;
    const displayId = getDisplayIdFromValue(order.OrderID);
    switch (orderStatusText) {
      case OrderStatusText.Filled:
      case OrderStatusText.FilledAndCanceled: {
        displayDescription = (
          <>
            Order {displayId} for {securityName} on <MarketAccountNames marketAccounts={order.tradedMarketAccounts} />
          </>
        );
        break;
      }
      default: {
        displayDescription = (
          <>
            Order {displayId} for {securityName}
          </>
        );
        break;
      }
    }
    return {
      order,
      displayDescription,
    };
  }, [props.description, security?.DisplaySymbol]);

  if (props.appInboxToastType === 'OrderStatus') {
    return (
      <AppInboxToastBase
        {...props}
        description={displayDetails.displayDescription}
        onToastClick={() => {
          const targetUrl = `/trading/order/${displayDetails.order.OrderID}/details`;
          dispatch(navigationSliceActions.navigate(targetUrl));
          // Close the notification for both toast and inbox variants
          dispatch(
            archiveNotification({
              NotificationID: props.id,
            })
          );
        }}
      />
    );
  }
  return null;
};
